export default {
	/* Courses  */
	classPackage: 'Packages',
	pendingCourses: 'Pending Courses',
	coursesFinished: 'Courses Finished',
	installZOOM: 'Install ZOOM',
	more: 'More',
	enter: 'Enter',
	download: 'Download',
	cancel: 'Cancel',
	notice: 'Notice',
	ok: 'OK',
	zoomTip: 'Please install ZOOM to experience your course.',
	noticeTip:
		'Please open the AirClass student client or mobile app to view class report and replay. You can click the button below to Download.',
	noticeTip2:
		'Please join our online classroom on AirClass student desktop client or mobile app. You can click the button below to Download.',
	zoomNoticeTip: 'The classroom will open 20 minutes before the start of class',
	airClassNoticeTip: 'The classroom will open 20 minutes before the start of class',
	monthData: {
		'01': 'January',
		'02': 'February',
		'03': 'March',
		'04': 'April',
		'05': 'May',
		'06': 'June',
		'07': 'July',
		'08': 'August',
		'09': 'September',
		'10': 'October',
		'11': 'November',
		'12': 'December',
	},
	lessonType: ['', 'Trial Lesson', 'Formal Lesson', 'device test time'],
	coursesEmpty: 'You don’t have a course yet',
	startIn: 'Start in',

	/* Profile Information */
	courses: 'Courses',
	ProfileInfor: 'Profile Information',
	TransRecord: 'Transation Record',
	/* Transation Record */
};
